var _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBeackerIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "background"), /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    id: "canvas_background",
    height: 402,
    width: 582,
    y: -1,
    x: -1
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", {
    fill: "#000066"
  }, "Layer 1"), /*#__PURE__*/React.createElement("path", {
    id: "svg_1",
    fill: "#000066",
    d: "m20.682,3.732c-0.473,-0.472 -1.1,-0.732 -1.768,-0.732s-1.295,0.26 -1.77,0.733l-1.41,1.412c-0.473,0.472 -0.734,1.1 -0.734,1.769c0,0.471 0.129,0.922 0.371,1.313l-13.577,5.439c-0.908,0.399 -1.559,1.218 -1.742,2.189c-0.185,0.977 0.125,1.979 0.834,2.687l12.72,12.58c0.548,0.548 1.276,0.859 2.045,0.877c0.018,0.001 0.06,0.001 0.078,0.001c0.202,0 0.407,-0.021 0.61,-0.062c0.994,-0.206 1.808,-0.893 2.177,-1.828l5.342,-13.376c0.402,0.265 0.875,0.407 1.367,0.407c0.67,0 1.297,-0.261 1.768,-0.733l1.407,-1.408c0.477,-0.474 0.738,-1.103 0.738,-1.773s-0.262,-1.3 -0.732,-1.768l-7.724,-7.727zm-4.023,25.635c-0.124,0.313 -0.397,0.544 -0.727,0.612c-0.076,0.016 -0.153,0.022 -0.229,0.021c-0.254,-0.006 -0.499,-0.108 -0.682,-0.292l-12.728,-12.588c-0.234,-0.233 -0.337,-0.567 -0.275,-0.893c0.061,-0.324 0.279,-0.598 0.582,-0.73l6.217,-2.49c4.189,1.393 8.379,0.051 12.57,4.522l-4.728,11.838zm10.333,-15.787l-1.414,1.413c-0.195,0.196 -0.512,0.196 -0.707,0l-1.768,-1.767l-1.432,3.589l0.119,-0.303c-3.01,-3.005 -6.069,-3.384 -8.829,-3.723c-0.887,-0.109 -1.747,-0.223 -2.592,-0.405l8.491,-3.401l-1.715,-1.715c-0.195,-0.195 -0.195,-0.512 0,-0.707l1.414,-1.415c0.195,-0.195 0.512,-0.195 0.707,0l7.725,7.727c0.198,0.195 0.198,0.512 0.001,0.707z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_2",
    fill: "#000066",
    d: "m16.5,21c1.378,0 2.5,-1.121 2.5,-2.5s-1.121,-2.5 -2.5,-2.5c-1.379,0 -2.5,1.121 -2.5,2.5s1.122,2.5 2.5,2.5zm0,-4c0.828,0 1.5,0.672 1.5,1.5s-0.672,1.5 -1.5,1.5c-0.829,0 -1.5,-0.672 -1.5,-1.5s0.671,-1.5 1.5,-1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_3",
    fill: "#000066",
    d: "m29.5,0c-1.379,0 -2.5,1.121 -2.5,2.5s1.121,2.5 2.5,2.5s2.5,-1.121 2.5,-2.5s-1.121,-2.5 -2.5,-2.5zm0,4c-0.828,0 -1.5,-0.672 -1.5,-1.5s0.672,-1.5 1.5,-1.5s1.5,0.672 1.5,1.5s-0.672,1.5 -1.5,1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_4",
    fill: "#000066",
    d: "m8,17c0,1.103 0.897,2 2,2s2,-0.897 2,-2s-0.897,-2 -2,-2s-2,0.897 -2,2zm2,-1c0.552,0 1,0.447 1,1s-0.448,1 -1,1s-1,-0.447 -1,-1s0.448,-1 1,-1z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "svg_5",
    r: 1,
    fill: "#000066",
    cy: 23,
    cx: 13
  }), /*#__PURE__*/React.createElement("circle", {
    id: "svg_6",
    r: 1,
    fill: "#000066",
    cy: 8,
    cx: 29
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBeackerIcon);
export default __webpack_public_path__ + "static/media/beacker-icon.ac3de2ff431350813769908100ed8410.svg";
export { ForwardRef as ReactComponent };